import { useTranslation } from 'react-i18next';

const LANGS = ['fr', 'en'];

function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage;

  return (
    <div className="lang-switch" role="group" aria-label="Language">
      {LANGS.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`lang-switch__btn ${current === lng ? 'is-active' : ''}`}
          onClick={() => {
            // Choix manuel : on le memorise pour ne plus forcer la langue via l'IP.
            localStorage.setItem('kmg_lang_choice', lng);
            i18n.changeLanguage(lng);
          }}
        >
          {t(`lang.${lng}`)}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
